import styles from './login.module.scss';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import ClearServices from '../../../Assets/Images/Logos/ClearServices Logos/ClearServices.png';
import InputField from '../../../Components/InputField/InputField';
import { loadingState } from '../../../Recoil/Atoms';
import Button from '../../../Components/Button/Button';
import AuthService from '../../../Services/auth.service';
import useInView from '../../../Components/UseInView/useInView';
import { handleError } from '../../../Services/api.service';

const ROLE_ROUTE = {
    Admin: '/admin/users',
    Maintenance: '/maintenance/maintenance-list',
    Tenant: '/tenant/dashboard',
};

const Login = () => {
    const [boxRef, boxVisible] = useInView();
    const navigate = useNavigate();
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [forgotPass, setForgotPass] = useState(false);
    const [, setLoading] = useRecoilState(loadingState);

    useEffect(() => {
        var response = AuthService.isLogged();
        if (response.auth) {
            navigate(ROLE_ROUTE[response.role]);
        }
    // eslint-disable-next-line
    }, []);

    const handleLogin = async () => {
        setLoading(true);
        try {
            const result = await AuthService.login(username, password);

            if (!result || !result.user?.role) {
                // Already handled by handleError inside AuthService
                return;
            }

            const { role } = result.user;
            navigate(ROLE_ROUTE[role] ?? '/');
        } catch (err) {
            handleError(err); // fallback if something really unexpected happens
        } finally {
            setLoading(false);
        }
    };


    const handleForgotPass = () => {
        setForgotPass(true);
    };

    const submitForgotPass = async () => {
        setLoading(true);
        try {
            await AuthService.forgotPass(email);
        } catch (err) {
            handleError(err);
        } finally {
            setLoading(false);
        }
    }
    
    return (
        <>
            <Helmet>
                <title>Clear Property Management - Property Management Services</title>
                <meta name='description' content='We provide property management services.' />
                <link rel='canonical' href='/' />
            </Helmet>

            <div className={styles.container}>
                <div
                    id='Login Landing'
                    ref={boxRef}
                    className={`${styles.wrapper} ${boxVisible ? styles.visible : ''}`}
                >
                    <a href='/'>
                        <img src={ClearServices} alt='ClearServices' />
                    </a>
                    <div className={styles.card}>
                        {forgotPass ?
                            <InputField
                                label='Email'
                                path='email.png'
                                placeholder='Enter email'
                                id='email'
                                name='email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                maxLength='25'
                            />
                        :
                            <>
                                <InputField
                                    label='Email / Username'
                                    path='user.png'
                                    placeholder='Enter email or username'
                                    id='username'
                                    name='username'
                                    value={username}
                                    onChange={(e) => setUserName(e.target.value)}
                                    maxLength='25'
                                />
                                <InputField
                                    label='Password'
                                    path='lock.png'
                                    placeholder='Enter password'
                                    type='password'
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    maxLength='25'
                                />
                            </>
                        }
                    </div>

                    <Button
                        buttonText={forgotPass ? 'Reset Password' : 'Login'}
                        displayIcon={true}
                        onClick={forgotPass ? submitForgotPass : handleLogin}
                    />

                    {
                        forgotPass ? 
                            null
                        :
                        <div className={styles.forgotPass}>
                            <p onClick={handleForgotPass}>
                                Forgot password?
                            </p>
                        </div>
                    }
                    <p className={styles.footerTag}>
                        © {new Date().getFullYear()} Clear Property Management
                    </p>
                </div>
            </div>
        </>
    );
};

export default Login;
